// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"Breadcrumbs--ZsBGo","breadcrumb":"breadcrumb--GhYRK","active":"active--oDtkA"};